import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgComponent } from 'icon';

@Component({
  selector: 'lib-product-card-bullet-list-header',
  imports: [CommonModule, SvgComponent],
  templateUrl: './product-card-bullet-list-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardBulletListHeaderComponent {
  public icon = input<string>();
}
